import { api } from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { AgentAdapter } from '@/adapters';
import type { Agent, ApiResponse, AgentResponseDto } from '@/types';

export const agentService = {
  /**
   * Get all agents for the user's account
   */
  async getAgents(): Promise<Agent[]> {
    const response = await api.get<ApiResponse<AgentResponseDto[]>>(API_ENDPOINTS.AGENTS.BASE);
    return AgentAdapter.fromApiList(response.data.data);
  }
};

